<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: zcy
 * @LastEditTime: 2022-04-13 10:35:13
-->
<template>
  <span>{{printVal}}</span>
</template>

<script>
export default {
  name: "count-in",
  props: {
    // startVal: 0,		// 起始值
    startVal: {
      type: [String, Number],
      default: "",
    },
    // endVal: 10,		// 最终值
    endVal: {
      type: [String, Number],
      default: "",
    },
    // speed: 500,		// 速度
    speed: {
      type: [String, Number],
      default: 5,
    },
    // decimals: 3,		// 保留几位小数（不会四舍五入）
    decimals: {
      type: [String, Number],
      default: 0,
    },
    // isReverse: false		// 是否允许从大到小（默认false）
    isReverse: {
      type: Boolean,
      default: false,
    },
    noAnimation:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      start: +this.startVal,
      end: +this.endVal,
      formatSpeed: +this.speed || 5,
    };
  },
  computed: {
    formatDecimals() {
      // 是否正整数
      let formatDecimals = this.decimals > 0 ? this.decimals : 0;
      return formatDecimals;
    },
    decimalsLen() {
      // 1 = 0.001 * decimalsLen(x);
      let decimalsLen = Math.pow(10, this.formatDecimals);
      return decimalsLen;
    },
    printVal() {
      // 保留几位小数
      let start = (
        parseInt(this.start * this.decimalsLen) / this.decimalsLen
      ).toFixed(this.formatDecimals);
      return start;
    },
  },
  watch: {
    isReverse: {
      deep: true,
      handler: function (newValue, oldValue) {
        this.isReverse = newValue;
        this.$nextTick(() => {
          this.accumulativeMachine();
        });
      },
    },
    endVal: {
      deep: true,
      handler: function (newValue, oldValue) {
        this.end = +newValue;
        this.$nextTick(() => {
          this.accumulativeMachine();
        });
      },
    },
  },
  methods: {
    accumulativeMachine() {
      if(!this.noAnimation){
        return this.start=this.end
      }
      setTimeout(() => {
        if (this.isReverse) {
          let decimals = this.formatDecimals === 0 ? 0 : 1 / this.decimalsLen;
          let formatSpeed = this.formatSpeed / this.decimalsLen + decimals;
          this.start -= formatSpeed;
          if (this.printVal <= this.end) {
            this.start = this.end;
            return;
          }
        } else {
          let decimals = this.formatDecimals === 0 ? 0 : 1 / this.decimalsLen;
          let formatSpeed = this.formatSpeed / this.decimalsLen + decimals;
          this.start += formatSpeed;
          if (this.printVal >= this.end) {
            this.start = this.end;
            return;
          }
        }
        this.accumulativeMachine();
      }, 8);
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.accumulativeMachine();
    });
  },
};
</script>

<style lang="less" scoped>
span {
  display: inline-block;
  width: 100%;
  font-size: 44px;
  font-family: DINCond-Black;
  font-weight: 400;
  color: #fbfbff;
  text-align: center;
  margin-top: 12px;
  overflow: hidden; //超出一行文字自动隐藏
  text-overflow: ellipsis; //文字隐藏后添加省略号
  white-space: nowrap; //强制不换行
}
</style>